import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router';
import { LoadingState } from '@/shared/components';
import { AppShell } from './AppShell';
import { NotFoundPage } from './NotFoundPage';

// The PDF viewer and the builder are the heaviest parts of the bundle; someone
// opening a link to sign a form should not download the administration UI.
const LoginPage = lazy(() => import('@/auth/LoginPage'));
const DashboardPage = lazy(() => import('@/forms/DashboardPage'));
const FormDetailPage = lazy(() => import('@/forms/FormDetailPage'));
const FormBuilderPage = lazy(() => import('@/forms/builder/FormBuilderPage'));
const SubmissionDetailPage = lazy(() => import('@/submissions/SubmissionDetailPage'));
const PublicFormPage = lazy(() => import('@/public-forms/PublicFormPage'));

const withSuspense = (element: React.ReactNode) => (
  <Suspense fallback={<LoadingState />}>{element}</Suspense>
);

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/dashboard" replace /> },
  { path: '/login', element: withSuspense(<LoginPage />) },

  // Public signing surface. Deliberately outside the authenticated shell.
  { path: '/f/:publicToken', element: withSuspense(<PublicFormPage />) },

  {
    element: <AppShell />,
    children: [
      { path: '/dashboard', element: withSuspense(<DashboardPage />) },
      { path: '/forms/:formId', element: withSuspense(<FormDetailPage />) },
      { path: '/forms/:formId/edit', element: withSuspense(<FormBuilderPage />) },
      {
        path: '/forms/:formId/responses/:submissionId',
        element: withSuspense(<SubmissionDetailPage />),
      },
    ],
  },

  { path: '*', element: <NotFoundPage /> },
]);
